import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Register from '../views/Register.vue'
import Dashboard from '../views/Dashboard.vue'
import store from '@/store/index.js'
import { firebase } from '@/firebase/firebase'
import NotFoundComponent from '@/components/NotFound'

Vue.use(VueRouter)

const routes = [{
		path: "/",
		name: "home",
		component: Home,
		meta: {
			title: "Home",
			loadUser: true,
			auth: false,
			navBar: true,
			appBarMobile: {
				title: false,
				bg: 'primary'
			}
		}
	},
	{
		path: "/dashboard",
		name: "dashboard",
		component: Dashboard,
		meta: {
			title: "Dashboard",
			auth: true,
			appBar: true,
			navBar: true
		}
	},
	{
		path: "/firms",
		name: "firms",
		component: () => import( /* webpackChunkName: "firms" */ "../views/Firms.vue"),
		meta: {
			title: "Firms",
			auth: true,
			appBar: true,
			navBar: true
		}
	},
	{
		path: "/setup",
		name: "setup",
		component: () => import( /* webpackChunkName: "account-setup" */ "../views/AccountSetup.vue"),
		meta: {
			title: "Account Setup",
			auth: true,
			appBar: true,
			navBar: true
		}
	},
	{
		path: "/clients",
		name: "clients",
		component: () => import( /* webpackChunkName: "customers" */ "../views/Customers.vue"),
		meta: {
			title: "Client Management",
			auth: true,
			appBar: true,
			navBar: true
		}
	},
	{
		path: "/admin/customers",
		name: "admin-customers",
		component: () => import( /* webpackChunkName: "admin-customers" */ "../views/AdminCustomers.vue"),
		meta: {
			title: "Customers",
			auth: true,
			appBar: true,
			navBar: true
		}
	},
	{
		path: "/marketing",
		name: "marketing",
		component: () => import( /* webpackChunkName: "marketing" */ "../views/Marketing.vue"),
		meta: {
			title: "Marketing",
			auth: true,
			appBar: true,
			navBar: true
		}
	},
	{
		path: "/support",
		name: "support",
		component: () => import( /* webpackChunkName: "support" */ "../views/Support.vue"),
		meta: {
			title: "Support",
			auth: true,
			appBar: true,
			navBar: true
		}
	},
	{
		path: "/users",
		name: "users",
		component: () => import( /* webpackChunkName: "users" */ "../views/Users.vue"),
		meta: {
			title: "Users",
			auth: true,
			appBar: true,
			navBar: true
		}
	},
	{
		path: "/profile",
		name: "profile",
		component: () => import( /* webpackChunkName: "profile" */ "../views/Profile.vue"),
		meta: {
			title: "Profile",
			auth: true,
			appBar: true,
			navBar: true
		}
	},
	// {
	// 	path: "/payment-methods",
	// 	name: "payment-methods",
	// 	component: () => import( /* webpackChunkName: "payment-methods" */ "../views/PaymentMethods.vue"),
	// 	meta: {
	// 		title: "Payment Methods",
	// 		auth: true,
	// 		appBar: true,
	// 		navBar: true
	// 	}
	// },
	{
		path: "/login",
		name: "Login",
		component: () => import( /* webpackChunkName: "login" */ "@/views/Login.vue"),
		meta: {
			title: "Login",
			vApp: true
		}
	},
	{
		path: "/register",
		name: "Register",
		// component: () => import( /* webpackChunkName: "register" */ "@/views/Register.vue" )
		component: Register,
		meta: {
			title: "Register",
			vApp: true
		}
	},
	{
		path: "/password-reset",
		name: "password-reset",
		component: () => import( /* webpackChunkName: "pw-reset" */ "@/views/PWReset.vue" ),
		meta: {
			title: "Password Reset",
			vApp: true
		}
	},
	{
		path: "/stripe-setup-success",
		name: "stripe-setup-success",
		component: () => import( /* webpackChunkName: "stripe-setup-success" */ "@/views/StripeSetupSuccess.vue"),
		meta: {
			title: "Payment Method Setup",
			vApp: true,
			auth: true
		}
	},
	{
		path: '*',
		component: NotFoundComponent
	}
]

const router = new VueRouter({
	mode: 'history',
	routes
})

const waitForAuth = () => {
	return new Promise((resolve, reject) => {
		const currentUser = firebase.auth().currentUser

		if (currentUser && store.state.user.auth_cb_init ) {
			resolve( currentUser )
		} else {
			firebase.auth().onAuthStateChanged(async (user) => {
				await store.dispatch('user/stateChanged', user)
				if( user ){
					resolve( user )
				} else {
					reject( user )
				}
			}, (error) => {
				console.log(error)
				reject()
			})
		}
	})
}

router.beforeEach(async (to, from, next) => {
	store.commit('SET_LOADING', true)
	document.title = `Otto - ${to.meta.title}`

	console.log(store.state.user, store.state.user.loggedIn)
	const loggedIn = store.state.user.loggedIn

    console.log('TO: ', Object.assign({}, to), loggedIn)
    console.log('From: ', Object.assign({}, from), loggedIn )

    if (to.matched.some(record => record.meta.auth)) {

		try {
			await waitForAuth()
			console.log('User is logged in, going to route')
			next()
		} catch( e ){
    		console.log('Not logged in, redirecting to login with redirect', to.fullPath)
    		next({ name: 'Login', query: { redirect: to.fullPath } })
		}

    } else {
		if (to.matched.some(record => record.meta.loadUser) ){
			try {
				await waitForAuth()
			} catch ( e ){

			}
		}
    	// Auth not required for this route
    	next()
    }

})

router.afterEach(() => {
	store.commit('SET_LOADING', false)
	// store.dispatch("routeComplete")
})

export default router
